<template>
  <div class="content profile-info">
    <div class="panel mt-3" style="align-items: center">
      <div>
        <v-layout column class="create">
          <v-tooltip left color="rgba(74,190,93,1)">
            <template v-slot:activator="{ on, attrs }">
              <v-flex class="avatar" v-bind="attrs" v-on="on">
                <v-icon id="upload-file-icon">upload_file</v-icon>
                <div
                  class="avatar-image"
                  :style="{ backgroundImage: avatarImage }"></div>
                <input
                  id="file-avatar"
                  type="file"
                  ref="avatar"
                  name="avatar"
                  @change="onFileChange" />
              </v-flex>
            </template>
            <span class="tooltip_text">Upload your profile image</span>
          </v-tooltip>
        </v-layout>
        <div :class="{ visible: !hasAvatar }" class="logo-text">
          Add a picture
        </div>
      </div>
      <v-form v-model="valid" ref="form">
        <template v-if="user.isBA">
          <div>
            <div class="align-center d-flex justify-space-between mb-3">
              <div>
                <div>
                  <span class="label">{{ form.accountType.label }}</span>
                </div>
                <div class="ambassador-value-panel">
                  <span class="value">{{ user.accountType.label }}</span>
                </div>
              </div>
              <div>
                <v-btn to="/ba-rewards" color="success" class="mr-0">
                  Rewards
                </v-btn>
              </div>
            </div>
            <div>
              <div class="align-center d-flex justify-space-between mb-3">
                <div>
                  <div>
                    <span class="label">{{ form.ambassadorCode.label }}</span>
                  </div>
                  <div class="ambassador-value-panel">
                    <span class="value">{{ user.ambassadorCode }}</span>
                  </div>
                </div>
                <div>
                  <img
                    style="cursor: pointer"
                    :src="constants.icons.contentCopyWhite"
                    v-clipboard:copy="user.ambassadorCode" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mb-3">
            <div>
              <span class="label">{{ form.accountType.label }}</span>
            </div>
            <!-- TODO [SP-273] Investigate why when user is NOT a brand ambassador this breaks -->
            <div class="ambassador-value-panel">
              <span class="value">{{ user.accountType.label }}</span>
            </div>
          </div>
        </template>
        <template v-if="!edit">
          <div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.email.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.email }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.firstName.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.firstName }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.lastName.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.lastName }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.phoneNumber.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.phoneNumber }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.birthDate.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.birthDate }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">{{ form.emergencyContactName.label }}</span>
              </div>
              <div>
                <span class="value">{{ user.emergencyContactName }}</span>
              </div>
            </div>
            <div class="mb-3">
              <div>
                <span class="label">
                  {{ form.emergencyContactPhoneNumber.label }}
                </span>
              </div>
              <div>
                <span class="value">
                  {{ user.emergencyContactPhoneNumber }}
                </span>
              </div>
            </div>
            <!-- <template v-if="this.user.accountType.type === 'player'">
              <div class="mb-3">
                <div>
                  <span class="label">{{form.veoProfileLink.label}}</span>
                </div>
                <div>
                  <span class="value">{{user.veoProfileLink}}</span>
                </div>
              </div>
            </template>-->
          </div>
        </template>
        <template v-else>
          <!-- TODO: [SP-361] fix the look of editable inputs -->
          <div class="mb-3">
            <div>
              <span class="label">{{ form.email.label }}</span>
            </div>
            <div>
              <span class="value">{{ user.email }}</span>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">
                {{ form.firstName.label }}
                <span v-if="form.firstName.required">*</span>
              </span>
            </div>
            <div>
              <v-text-field
                dark
                solo-inverted
                clearable
                v-model="user.firstName"
                :rules="form.firstName.validationRules"
                :required="form.firstName.required"></v-text-field>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">
                {{ form.lastName.label }}
                <span v-if="form.lastName.required">*</span>
              </span>
            </div>
            <div>
              <v-text-field
                dark
                solo-inverted
                clearable
                v-model="user.lastName"
                :rules="form.lastName.validationRules"
                :required="form.lastName.required"></v-text-field>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">
                {{ form.phoneNumber.label }}
                <span v-if="form.phoneNumber.required">*</span>
              </span>
            </div>
            <div>
              <v-text-field
                dark
                solo-inverted
                clearable
                @focus="clearNAvalue('phoneNumber')"
                v-model="user.phoneNumber"
                :rules="form.phoneNumber.validationRules"
                :required="form.phoneNumber.required"></v-text-field>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">
                {{ form.birthDate.label }}
                <span v-if="form.birthDate.required">*</span>
              </span>
            </div>
            <div>
              <v-menu
                v-model="form.birthDate.picker.active"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dark
                    solo-inverted
                    clearable
                    v-model="user.birthDate"
                    :rules="form.birthDate.validationRules"
                    readonly
                    :required="form.birthDate.required"
                    v-bind="attrs"
                    v-on="on"
                    @focus="clearNAvalue('birthDate')"></v-text-field>
                </template>
                <v-date-picker
                  v-model="user.birthDate"
                  :allowedDates="form.birthDate.allowedDates"
                  dark
                  no-title
                  @input="form.birthDate.picker.active = false"></v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">{{ form.emergencyContactName.label }}</span>
            </div>
            <div>
              <v-text-field
                dark
                solo-inverted
                clearable
                v-model="user.emergencyContactName"
                :rules="form.emergencyContactName.validationRules"
                required></v-text-field>
            </div>
          </div>
          <div class="mb-0">
            <div>
              <span class="label">
                {{ form.emergencyContactPhoneNumber.label }}
              </span>
            </div>
            <div>
              <v-text-field
                dark
                solo-inverted
                clearable
                v-model="user.emergencyContactPhoneNumber"
                :rules="form.emergencyContactPhoneNumber.validationRules"
                required></v-text-field>
            </div>
          </div>
          <!-- <template v-if="this.user.accountType.type === 'player'">
            <div class="mb-0">
              <div>
                <span class="label">{{form.veoProfileLink.label}}</span>
              </div>
              <div>
                <v-text-field
                  dark
                  solo-inverted
                  clearable
                  v-model="user.veoProfileLink"
                  :rules="form.veoProfileLink.validationRules"
                ></v-text-field>
              </div>
            </div>
          </template>-->
        </template>
        <div v-if="this.canEdit">
          <!-- :dark="!edit" -->
          <v-btn
            dark
            @click="!edit ? (edit = !edit) : updateProfile()"
            color="success"
            block
            :disabled="!valid && edit"
            :loading="submitLoading"
            class="ml-0">
            {{ edit ? "Save Changes" : "Edit Profile" }}
          </v-btn>
        </div>
      </v-form>
      <v-flex class="bp_connection_btn" v-if="this.canEdit">
        <template
          v-if="
            this.$store.getters['user/isPlayer'] && bpAuth === 'logged out'
          ">
          <div>
            <v-btn @click="bpConnectDialog" color="warning" class="mr-0 ml-0">
              Connect to Beyond Pulse
            </v-btn>
          </div>
        </template>
        <template
          v-if="this.$store.getters['user/isPlayer'] && bpAuth === 'logged in'">
          <div>
            <v-btn
              color="error"
              class="mr-0 ml-0"
              :loading="disconnectLoading"
              @click="disconnectFromBP()">
              Disconnect from Beyond Pulse
            </v-btn>
          </div>
        </template>
      </v-flex>
    </div>
  </div>
</template>

<script>
// import { apiWrapper } from "@/lib/utils"
import api from "@/api/firebase.api.js"
import { updateUserProfile } from "@/api/updateUserProfile.ts"
// import beyondPulseApi from "@/api/beyondpulse.api.js"
import { bpLogout } from "@/api/bpServiceUtils"
import moment from "moment"
import constants from "@/constants.js"
import { mapGetters, mapState } from "vuex"
import defaultProfileImage from "@/assets/icons/default_profile_image.png"

export default {
  name: "ProfileInfo",
  components: {},
  data() {
    return {
      hasAvatar: false,
      submitLoading: false,
      disconnectLoading: false,
      user: {
        isActiveBeyondPulsePlayer: false,
        email: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        birthDate: "",
        emergencyContactName: "",
        emergencyContactPhoneNumber: "",
        accountType: {},
      },
      valid: false,
      imgUrl: "",
      edit: false,
      constants,
      form: {
        email: {
          label: "Email",
          required: true,
        },
        firstName: {
          label: "Firstname",
          required: true,
          validationRules: [(v) => !!v || "Firstname is required"],
        },
        lastName: {
          label: "Lastname",
          required: true,
          validationRules: [(v) => !!v || "Lastname is required"],
        },
        // veoProfileLink: {
        //   label: "Veo profile link"
        // },
        phoneNumber: {
          label: "Phone Number",
          required: true,
          validationRules: [
            (v) => !!v || "Phone number is required",
            (v) => (/^\+?[\d\s]{3,}$/.test(v) ? true : "Invalid format"),
          ],
        },
        birthDate: {
          label: "Date of Birth",
          required: true,
          validationRules: [(v) => !!v || "Date of Birth is required"],
          picker: {
            active: false,
          },
          allowedDates: (val) => {
            return moment(val, "YYYY-MM-DD").isBefore()
          },
        },
        emergencyContactName: {
          label: "Emergency Contact Name",
        },
        emergencyContactPhoneNumber: {
          label: "Emergency Contact Phone Number",
        },
        accountType: {
          label: "Account Type",
        },
        ambassadorCode: {
          label: "Ambassador Code",
        },
      },
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      // console.log("route has id - ", this.$route.params.id)
      const playerId = this.$route.params.id
      this.user = await api.getUserDataPromiseFactory(playerId)
      // if (!this.user) {
      //   this.user = this.$store.user.profile
      // }
      this.user.accountType = {
        label: this.user.coachOrPlayer,
        type: this.user.coachOrPlayer,
      }
      // console.log(this.user)
      // this.$forceUpdate()
    }
    // else {
    if (!this.$route.params.id) {
      // this.user = this.$store.state.user.profile
      this.user = await this.awaitUserProfileOnReload()
      // console.log("user profile ", this.user)

      this.user = {
        ...this.user,
        ...{
          isActiveBeyondPulsePlayer:
            !!this.$store?.state?.user?.profile?.beyond_pulse_id,
          email: this.$store?.state?.user?.profile?.email,
          firstName: this.$store?.state?.user?.profile?.firstName,
          lastName: this.$store?.state?.user?.profile?.lastName,
          phoneNumber:
            this.user.cellPhone ??
            this.$store?.state?.user?.profile?.phone_number,
          birthDate: this.$store?.state?.user?.profile?.birthDate,
          emergencyContactName:
            this.$store?.state?.user?.profile?.emergency_contact_full_name ||
            "N/A",
          emergencyContactPhoneNumber:
            this.$store?.state?.user?.profile?.emergency_contact_phone || "N/A",
          accountType: this.$store?.state?.user?.profile.brand_ambassador
            ? { label: "Brand Ambassador" }
            : this.$store?.state?.user?.profile?.accountType,
          ambassadorCode: this.$store?.state?.user?.profile.brand_ambassador
            ? this.$store.state.user.ba.discountCode
            : "",
          isBA: !!this.$store?.state?.user?.profile.brand_ambassador,
        },
        accountType: {
          label: this.accountType.label,
          type: this.accountType.type,
        },
      }
    }
  },
  computed: {
    // TODO [SP-272] fix interpolation of avatar image
    avatarImage() {
      const defaultImgRX = /^https?:\/\/.*defaultProfileImg\.png.*/gm
      const inheritedImg =
        this.imgUrl ||
        this.user.imgUrl ||
        this.$store?.state?.user?.profile?.imgUrl
      if (defaultImgRX.test(inheritedImg) || !inheritedImg) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.hasAvatar = false
        return `url(${defaultProfileImage})`
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.hasAvatar = true
        return `url(${inheritedImg})`
      }
    },
    ...mapGetters({ accountType: "user/accountType" }),
    ...mapState("user", {
      awaitedUser: (state) => {
        return state.profile
      },
      bpAuth: (state) => {
        return state.bpAuth
      },
    }),

    /**
     * checks whether the currently logged in user is the same as the user presented in the view \
     * If this.$route.params.id has no id, it means the user clicked on their own profile pic (top right)
     *
     * TODO: [SP-300] do we want to allow Coaches to edit this information?
     */
    canEdit() {
      if (this.$route.params.id) {
        return this.$store.state.user.current.uid === this.$route.params.id
      } else {
        return true
      }
    },
  },
  methods: {
    bpConnectDialog() {
      this.$emit("show-message-dialog", {
        message: false,
        component: "bpConnect",
      })
    },
    awaitUserProfileOnReload() {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          const userData = this.awaitedUser || {}
          if (Object.keys(userData).length) {
            clearInterval(interval)
            resolve(userData)
          }
        }, 1000)
      })
    },
    clearNAvalue(field) {
      if (String(this.user[field]).toLowerCase() === "n/a") {
        this.user[field] = undefined
      }
      if (field === "birthDate") {
        this.form.birthDate.picker.active = true
      }
    },
    onFileChange(event) {
      this.readURL(event.target)
    },

    readURL(input) {
      if (input.files && input.files[0]) {
        const file = input.files[0]
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgUrl = event.target.result
          this.form.avatar = file
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    async updateProfile() {
      if (!this.valid) {
        return
      }

      const payload = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        cellPhone: this.user.phoneNumber,
        birthDate: this.user.birthDate,
        emergContact: this.user.emergency_contact_full_name || "",
        emergContactCell: this.user.emergency_contact_phone || "",
        // veoProfileLink: this.user.veoProfileLink || ""
      }
      // console.log("update payload ", payload)
      this.submitLoading = true
      try {
        const report = await updateUserProfile(
          this.$route.params.id || this.$store.state.user.current.uid,
          payload,
          this.form.avatar
        )
        if (report) {
          this.submitLoading = false
          this.$store.dispatch("user/load", this.$store.state.user.current.uid)
          this.edit = false
        }
      } catch (e) {
        this.$toast.error(e.message)
      }
    },
    async disconnectFromBP() {
      this.disconnectLoading = true

      try {
        const response = await bpLogout()
        this.$store.dispatch("user/updateBPauth", response)
      } catch (e) {
        this.$toast.error(e.message)
      }

      this.disconnectLoading = false
    },
  },
  watch: {
    "$store.state.user.profile.beyondPulse": function (newVal, oldVal) {
      if (newVal) {
        this.user.isActiveBeyondPulsePlayer = true
      } else {
        this.user.isActiveBeyondPulsePlayer = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/globals.sass'

.content
  // height: calc(100vh - 85px)
  // overflow: scroll
  display: flex
  flex-grow: 1
  color: white
  justify-content: center
  margin-top: 5px
  margin-bottom: 4.5rem

.panel
  align-items: center
  display: flex
  flex-direction: column

.label
  font-weight: bold

.ambassador-value-panel
  display: flex
  justify-content: space-between
.visible
  visibility: visible !important
.avatar
  overflow: hidden
  width: 150px
  align-self: center
  position: relative
  .avatar-image
    max-width: 150px
    background: center center no-repeat
    background-size: cover
    border-radius: 50%
    padding-top: 100%
    position: relative
    width: 100%
    height: 0
    left: 0
    top: 0
  input
    cursor: pointer
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    opacity: 0

.logo, .logo-text, .logo-icon
  align-self: center
  margin: 0.5em 0
  color: $white
  font:
    size: 1.2em
  text-align: center
.logo-text
  visibility: hidden

.create
  flex: 0 1 auto
  position: relative
  justify-content: center
  display: flex

.logo
  justify-content: center

.v-text-field
  padding-top: 0
  margin-top: 0

// .v-text-field .v-text-field__slot
//   background: white

.rewards-link
  color: $white
.bp_connection_btn
  margin: 1rem 0
</style>
